import { createStore, applyMiddleware } from 'redux';
import { reducers } from '../../rootReducer';
import { IAppState, initialAppState } from './reduxState';
import { composeWithDevTools } from 'redux-devtools-extension';

export const createAppStore  = (initialState: Partial<IAppState> = {}) =>  createStore(reducers, { ...initialAppState, ...initialState }, composeWithDevTools());
